import LanguageDTO from './languageDTO';

export default class NormControl_TranslationDTO {
  normId: number;

  controlId: number;

  languageId: number;

  implementation?: string;

  lang?: LanguageDTO;

  constructor() {
    this.normId = 0;
    this.controlId = 0;
    this.languageId = 0;
  }
}
